require('/ui/components/entitypicker/header/header.module.scss.module.css');

export const header = "_header_1fy6h_1";
export const heading = "_heading_1fy6h_1";
export const smallViewportSupport = "_small-viewport-support_1fy6h_1";
export const dropdownIcon = "_dropdown-icon_1fy6h_1";
